import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Link from 'components/link';
import { flexCenter } from '@seedlang/style_mixins';
import { isBlank } from '@seedlang/utils';

const BreadcrumbWrapper = styled.div`
  ${flexCenter()}
  text-transform: uppercase;
`;

const Title = styled.div`
  text-decoration: ${props => props.textDecoration};
  padding: ${props => props.padding};
  cursor: ${props => props.cursor};
  font-size: 14px;
  font-weight: bold;
  color: #333;
`;

@observer
class HeaderBarItem extends React.Component {
  @observable page;

  get routeName() {
    return Array.isArray(this.props.item) ? this.props.item[0] : this.props.item.route;
  }

  get label() {
    return Array.isArray(this.props.item) ? this.props.item[1] : this.props.item.name;
  }

  get routeParams() {
    const params = Array.isArray(this.props.item) ? {} : (this.props.item.params || {});
    if (this.props.lookupPage) {
      return Object.assign({}, params, isBlank(this.page) ? { page: 1 } : { page: this.page });
    }
    return params;
  }

  componentDidMount() {
    if (this.props.lookupPage) {
      const page = window.location.href.split('page/')[1];
      this.page = page;
    }
  }

  render() {
    return (
      <React.Fragment>
        <i className='fa fa-angle-right' />
        <BreadcrumbWrapper>
          <Link
            to={{name: this.routeName, params: this.routeParams}}
          >
            <Title
              textDecoration='underline'
              padding='0 5px'
            >
              {this.label}
            </Title>
          </Link>
        </BreadcrumbWrapper>
      </React.Fragment>
    );
  }
}

export default ErrorBoundary(HeaderBarItem);
